import { mode } from '@chakra-ui/theme-tools';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter/900.css';
import './styles.css';

export const globalStyles = {
  styles: {
    global: (props) => ({
      body: {
        bg: mode('#f1f1f1', '#202124')(props), 
        fontFamily: '\'Inter\', sans-serif',
        position: 'relative'
      },
      '*': {
        overflow: 'hidden',
        outline: 'none !important',
        userSelect: 'none !important',
        '-webkit-user-select': 'none !important',
        '-ms-user-select': 'none !important',
        '-moz-user-select': 'none !important',
        '-webkit-tap-highlight-color': 'transparent !important'
      },
      html: {
        fontFamily: '\'Inter\', sans-serif',
      },
      '.chakra-modal__content': { 
        bg: 'transparent !important',
        boxShadow: 'unset !important'
      },
      '.hidden': {
        opacity: '0',
        pointerEvents: 'none'
      },
      '.chakra-form-control': { overflow: 'visible' },
      'input.input-invalid': { borderColor: 'red !important' },
      'select.input-invalid': { borderColor: 'red !important' },
      '.input-invalid': {
        input: { borderColor: 'red !important' },
      },
      'label.input-invalid': { color: 'red !important' },
      'button.freeze': { pointerEvents: 'none' },
      '.freeze': { pointerEvents: 'none', opacity: '0.3' },
      '.freeze-iframe': { pointerEvents: 'none', opacity: '0.7' },
      '.input-error': {
        top: 0,
        left: 0,
        zIndex: 2,
        position: 'absolute',
        pointerEvents: 'none',
        mx: '14px !important',
        px: '4px !important',
        my: '15px !important',
        transformOrigin: 'left top',
        color: 'red !important',
        fontWeight: '400',
        fontSize: '14px',
        transform: 'scale(0.85) translateY(35px)',
        lineHeight: 'normal !important',
      },
    })
  }
};
